import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const BottomNavbar = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    bottomNavbar: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#fbf0f0",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "12px 8px",
      paddingBottom: "calc(12px + env(safe-area-inset-bottom))",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
      zIndex: 1000,
      borderTop: "1px solid #f0e0e0",
      height: isMobile ? "70px" : "80px",
    },
    bottomNavItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#2e2c3b",
      padding: "8px 12px",
      borderRadius: "8px",
      transition: "background-color 0.2s",
      position: "relative",
      flex: 1,
      minWidth: isMobile ? "50px" : "70px",
    },
    bottomNavItemActive: {
      color: "#2e2c3b",
    },
    bottomNavIconWrapper: {
      width: "48px",
      height: "48px",
      borderRadius: "24px",
      backgroundColor: "#e0d8f0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "6px",
      transition: "background-color 0.2s",
    },
    bottomNavIcon: {
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#2e2c3b",
    },
    bottomNavLabel: {
      fontSize: "12px",
      fontWeight: "bold",
      color: "#2e2c3b",
      letterSpacing: "-0.01em",
      marginTop: "0px",
      lineHeight: "14px",
      textAlign: "center",
    },
  };

  const isActive = (path) => {
    if (path === "/my-business") {
      return location.pathname === "/my-business" || location.pathname === "/dashboard";
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <nav style={styles.bottomNavbar}>
      {/* Home Button - Active when on /my-business or /dashboard */}
      <Link
        to="/my-business"
        style={{
          ...styles.bottomNavItem,
          ...(isActive("/my-business") ? styles.bottomNavItemActive : {}),
        }}
        title="Home"
      >
        {isActive("/my-business") ? (
          <>
            <div
              style={{
                ...styles.bottomNavIconWrapper,
                width: isMobile ? "44px" : "48px",
                height: isMobile ? "44px" : "48px",
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                  fill="#2e2c3b"
                />
                <path
                  d="M9 13h6"
                  stroke="#2e2c3b"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <circle cx="12" cy="10" r="1.5" fill="#2e2c3b" />
              </svg>
            </div>
            <span style={styles.bottomNavLabel}>Home</span>
          </>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="#2e2c3b" />
          </svg>
        )}
      </Link>

      {/* Party Button */}
      <Link
        to="/parties"
        style={{
          ...styles.bottomNavItem,
          ...(isActive("/parties") ? styles.bottomNavItemActive : {}),
        }}
        title="Parties"
      >
        {isActive("/parties") ? (
          <div
            style={{
              ...styles.bottomNavIconWrapper,
              width: isMobile ? "44px" : "48px",
              height: isMobile ? "44px" : "48px",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                fill="#2e2c3b"
              />
            </svg>
          </div>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
              fill="#2e2c3b"
            />
          </svg>
        )}
      </Link>

      {/* Products Button */}
      <Link
        to="/products"
        style={{
          ...styles.bottomNavItem,
          ...(isActive("/products") ? styles.bottomNavItemActive : {}),
        }}
        title="Products"
      >
        {isActive("/products") ? (
          <div
            style={{
              ...styles.bottomNavIconWrapper,
              width: isMobile ? "44px" : "48px",
              height: isMobile ? "44px" : "48px",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
                fill="#2e2c3b"
              />
            </svg>
          </div>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
              fill="#2e2c3b"
            />
          </svg>
        )}
      </Link>

      <Link
        to="/contacts"
        style={{
          ...styles.bottomNavItem,
          ...(isActive("/contacts") ? styles.bottomNavItemActive : {}),
        }}
        title="contacts"
      >
        {isActive("/contacts") ? (
          <div
            style={{
              ...styles.bottomNavIconWrapper,
              width: isMobile ? "44px" : "48px",
              height: isMobile ? "44px" : "48px",
            }}
          >
            {/* ACTIVE WHATSAPP ICON */}
            <svg
              width="24"
              height="24"
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#2e2c3b"
                d="M16.04 2.003C8.29 2.003 2 8.293 2 16.043c0 2.74.79 5.29 2.15 7.45L2 30l6.7-2.08a13.94 13.94 0 007.34 2.04c7.75 0 14.04-6.29 14.04-14.04S23.79 2.003 16.04 2.003z"
              />
              <path
                fill="#fff"
                d="M23.5 19.6c-.3-.15-1.8-.9-2.08-1s-.48-.15-.68.15-.78 1-.96 1.2-.36.22-.66.07a11.4 11.4 0 01-3.35-2.06 12.6 12.6 0 01-2.33-2.9c-.24-.4.25-.37.7-1.24.1-.2.05-.37-.02-.52s-.68-1.63-.94-2.23c-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.52.07-.8.37s-1.05 1.03-1.05 2.5 1.08 2.9 1.23 3.1c.15.2 2.13 3.25 5.16 4.56.72.3 1.28.48 1.72.62.72.23 1.37.2 1.88.12.57-.08 1.8-.73 2.05-1.43.25-.7.25-1.3.18-1.43-.07-.12-.27-.2-.57-.35z"
              />
            </svg>
          </div>
        ) : (
          /* INACTIVE WHATSAPP ICON */
          <svg
            width="24"
            height="24"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#2e2c3b"
              d="M16.04 2.003C8.29 2.003 2 8.293 2 16.043c0 2.74.79 5.29 2.15 7.45L2 30l6.7-2.08a13.94 13.94 0 007.34 2.04c7.75 0 14.04-6.29 14.04-14.04S23.79 2.003 16.04 2.003z"
            />
            <path
              fill="#fff"
              d="M23.5 19.6c-.3-.15-1.8-.9-2.08-1s-.48-.15-.68.15-.78 1-.96 1.2-.36.22-.66.07a11.4 11.4 0 01-3.35-2.06 12.6 12.6 0 01-2.33-2.9c-.24-.4.25-.37.7-1.24.1-.2.05-.37-.02-.52s-.68-1.63-.94-2.23c-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.52.07-.8.37s-1.05 1.03-1.05 2.5 1.08 2.9 1.23 3.1c.15.2 2.13 3.25 5.16 4.56.72.3 1.28.48 1.72.62.72.23 1.37.2 1.88.12.57-.08 1.8-.73 2.05-1.43.25-.7.25-1.3.18-1.43-.07-.12-.27-.2-.57-.35z"
            />
          </svg>
        )}
      </Link>
    </nav>
  );
};

export default BottomNavbar;
